<template>
    <div class="page-edit audit-equipment-edit layout-max-width mt-3 mt-lg-0">

        <data-form v-if="showEditor"
                   class="audit-equipment-edit__form"
                   title="Edit Equipment Issue"
                   save-button-label="Save Equipment"
                   :field-model="auditEquipmentFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="cancelRoute"
                   submit-success-message="Audit Issue Edited"
                   submit-error-message="Error Saving Audit Issue"
                   :submit-success-route="saveRoute"
                   @changed="changed"/>
        <template v-else>
            <h1 class="mb-2">Equipment Issue</h1>
            <audit-equipment-summary :audit-equipment="auditEquipment"/>
        </template>
        <audit-equipment-comments
            v-if="auditEquipment"
            @comment-added="commentAdded"
            :audit-equipment-id="auditEquipmentId"
            :audit-equipment-comments="auditEquipment.auditEquipmentComments"/>
        <equipment-view-details
            v-if="auditEquipment"
            :equipment="equipment"/>

        <div class="audit-history">
            <b-card-header>
                <h3>History</h3>
            </b-card-header>
            <b-card-body>
                <log-entries table="audit-equipment" :model-instance-id="auditEquipmentId"
                             class="table-responsive"/>
            </b-card-body>
        </div>

        <attachment-list class="mt-2 table-responsive"
                         model-class="AuditEquipment"
                         model-table="audit-equipment"
                         :model-id="auditEquipmentId"
                         :readOnly="false"/>
    </div>
</template>

<script>

import Vue from 'vue'
import AuditEquipmentFields from '@/models/AuditEquipment'
import AuditEquipmentComments from '@/components/AuditEquipmentComments'
import LogEntries from '@/components/LogEntries'
import Authorization from '@/providers/Authorization'

/**
 * Page for admin to edit agency information
 */
export default Vue.extend({
    name: 'AuditEquipmentEdit',
    components: { LogEntries, AuditEquipmentComments },
    props: {
        auditEquipmentId: Number,
        viewOnly: Boolean,
    },
    data () {
        return {
            auditEquipmentFields: AuditEquipmentFields,
            fieldGroups: [
                ['equipment', 'status', 'category', 'follow_up', 'comment', 'resolved_reason'],
            ],

            auditEquipment: null,
            equipment: null,

            canEdit: false
        }
    },
    computed: {
        saveRoute () {
            return this.auditEquipment ? `/auditEquipment/create/${this.auditEquipment.audit_id}` : '/'
        },
        cancelRoute () {
            return this.auditEquipment ? `/audit/edit/${this.auditEquipment.audit_id}` : '/'
        },
        showEditor () {
            return this.canEdit && this.auditEquipment && this.auditEquipment.auditIsOpen && !this.viewOnly
        }
    },
    methods: {
        loadModelInstance () {
            return this.$api.getItem(this, 'audit-equipment',
                this.auditEquipmentId,
                ['equipment', 'auditEquipmentComments', 'auditEquipmentComments.user', 'userLogs'])
                .then((auditEquipment) => {
                    this.auditEquipment = auditEquipment
                    this.equipment = auditEquipment.equipment
                    return auditEquipment
                })
        },
        onSubmit (modelInstance) {
            return this.$api.updateItem(this, 'audit-equipment', modelInstance)
        },
        changed (fieldName, form) {
            this.equipment = form.equipment
        },
        commentAdded () {
            this.loadModelInstance()
        },
    },
    created () {
        this.loadModelInstance()
        Authorization.can({ action: 'edit', model: 'audit-equipment', arg: this.auditEquipmentId })
            .then((canEdit) => {
                this.canEdit = canEdit
            })

    }
})

</script>

<style lang="scss">
.audit-equipment-edit {
    form {
        @media(min-width: 576px) {
            .data-form-input:first-child {
                width: 100%;
            }
            .data-form-input {
                width: 48%;
            }

            .form-elements {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
            }
        }
    }
}

</style>